import { DYNAMIC_LAYOUT_ADMIN } from '../../constants/userRoles';

export const deserializeUser = ({
    id,
    firstName,
    lastName,
    email,
    roles,
    enabled=true,
    signatureBase64,
    unitOfMeasure,
    contactInfo,
    licenseInfo,
    company,
    timeZoneId,
    tzAbbr,
    eula,
    isIsnCredentialsPresent
  }={}) => {

  company = company || {};
  licenseInfo = licenseInfo || {};
  contactInfo = contactInfo || {};
  roles = roles || [];

  // add after addition of using multiple roles, example roles = [DYNAMIC_LAYOUT_ADMIN, SPRUCE_ADMIN]
  const role = roles[0] !== DYNAMIC_LAYOUT_ADMIN ? roles[0] : roles[1];

  const address = contactInfo.address || {};

  return {
    id,
    firstName,
    lastName,
    email,
    enabled,
    signatureBase64,
    timeZoneId,
    tzAbbr,
    eula,
    role,
    roles,
    uom: unitOfMeasure,
    companyId: company.id,
    companyName: company.name,
    companySubscription: company.subscription,
    isIsn: company.isIsn,
    isnDomain: company.isnDomain,
    isnKey: company.isnKey,
    fax: contactInfo.fax,
    phone: contactInfo.phone,
    address1: address.address1,
    address2: address.address2,
    city: address.city,
    country: address.country,
    county: address.county,
    postalCode: address.postalCode,
    state: address.state,
    stateCertification: licenseInfo.stateCertification,
    license1: licenseInfo.license1,
    license2: licenseInfo.license2,
    license3: licenseInfo.license3,
    license4: licenseInfo.license4,
    license5: licenseInfo.license5,
    isIsnCredentialsPresent
  }
};

export const serializeUser = (user={}) => {
  return {
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    role: user.role,
    roles: user.roles,
    password: user.password,
    unitOfMeasure: user.uom,
    signImageFileName: user.signImageFileName,
    signatureBase64: user.signatureBase64,
    companyId: user.companyId,
    timeZoneId: user.timeZoneId,
    accessKey: user.accessKey,
    secretKey: user.secretKey,
    contactInfo: {
      fax: user.fax,
      phone: user.phone,
      address: {
        address1: user.address1,
        address2: user.address2,
        city: user.city,
        state: user.state,
        postalCode: user.postalCode,
        country: user.country,
        county: user.county
      },
    },
    licenseInfo: {
      stateCertification: user.stateCertification,
      license1: user.license1,
      license2: user.license2,
      license3: user.license3,
      license4: user.license4,
      license5: user.license5
    }
  }
};



// WEBPACK FOOTER //
// src/actions/profile/serializers.js